import { Avatar, AvatarGroup } from '@carnica/ui-kit';
import React from 'react';
import { FUB_COMMON_STATUS, fubTexts } from "../constants";
import { getItems } from "./fub";
export var renderRightSide = function renderRightSide(status, members, isError) {
  var avatar = /*#__PURE__*/React.createElement(Avatar, {
    image: fubTexts.avatar.default,
    size: "m",
    "data-t-id": "ConnectionBlock-utils"
  });
  if (isError) {
    return avatar;
  }
  switch (status.toLowerCase()) {
    case FUB_COMMON_STATUS.AVAILABLE:
      return avatar;
    case FUB_COMMON_STATUS.MASTER:
      {
        return /*#__PURE__*/React.createElement(AvatarGroup, {
          items: getItems(members),
          size: "s",
          visibleCount: 4
        });
      }
    case FUB_COMMON_STATUS.SLAVE:
      return /*#__PURE__*/React.createElement(AvatarGroup, {
        items: getItems(members),
        size: "s",
        visibleCount: 4
      });
    default:
      return avatar;
  }
};